import { formatIntegerIN } from '../lib/format';

interface ReportingKpiValues {
  reach: number;
  engagement: number;
}

// Complete figures behind the compact Reporting KPI tiles, keyed by tile label.
export function reportingKpiTooltips({ reach, engagement }: ReportingKpiValues) {
  return {
    Views: reach > 0 ? formatIntegerIN(reach) : undefined,
    Engagement: engagement > 0 ? `${engagement.toFixed(2)}%` : undefined,
  };
}
